import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import GenieSpinner from '../components/core/genie-spinner/GenieSpinner';

const Logout: React.FC = () => {
  const { logout, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      // Logout the user and redirect to home page
      localStorage.removeItem("buyer_invite_id");
      localStorage.removeItem("buyer_org_id");
      logout({
        returnTo: window.location.origin,
        federated: true
      });
    } else if (!isLoading && !isAuthenticated) {
      // User is already logged out, redirect to home
      navigate('/');
    }
  }, [logout, isAuthenticated, isLoading, navigate]);

  // Show loading spinner while processing logout
  return <GenieSpinner />;
};

export default Logout;
